import exportExcel from '@ubeya/shared/utils/exportExcel';
import { formatBalanceUnitSuffix, LEAVE_BALANCE_UNIT } from './leaveBalanceUtils';
import { formatDate } from './leaveFormatters';
import { resolveLedgerEventType, resolveLedgerReason } from './ledgerFormatters';

const resolveUnitLabel = ({ unit, t, currency }) =>
  unit === LEAVE_BALANCE_UNIT.Money ? currency : formatBalanceUnitSuffix({ unit }, t).trim();

const exportLedgerToExcel = ({ ledger, employeeName, t, formattingMap, currency }) => {
  const baseData = ledger.map((row) => ({
    [t('employeeLeave_history_col_date')]: formatDate(formattingMap, row.occurredAt),
    [t('leaveType')]: row.leaveTypeName || '',
    [t('employeeLeave_history_col_type')]: resolveLedgerEventType(row, t),
    [t('employeeLeave_history_col_change')]: Math.round(Number(row.amount ?? 0) * 100) / 100,
    [t('unit')]: resolveUnitLabel({ unit: row.unit, t, currency }),
    [t('employeeLeave_history_col_reason')]: resolveLedgerReason(row.metadata, t)
  }));

  return exportExcel({ baseData, name: `Ledger_History_${employeeName}` });
};

export default exportLedgerToExcel;
